
import { Vue, Component, Prop, mixins } from 'nuxt-property-decorator'
import axios from 'axios'
import Blocks from '~/mixins/blocks'

@Component
export default class HeroComponent extends mixins(Blocks) {
  @Prop({ required: true, type: Object }) block: Record<string, any>

  trustpilotCustomers: string = '0'

  async created() {
    const trustPilotConfig = this.$config.trustPilot
    const trustpilotURL = `https://api.trustpilot.com/v1/business-units/${trustPilotConfig.id}`

    try {
      const axiosInstance = axios.create() as any
      const response = await axiosInstance.get(trustpilotURL, {
        params: {
          apikey: trustPilotConfig.apiKey,
        },
      })
      if (response.status === 200 && response.data) {
        this.trustpilotCustomers = Number(
          response.data.numberOfReviews.total
        ).toLocaleString()
      }
    } catch (err) {
      console.log('Trustpilot error', err)
    }
  }

  get imageData() {
    const imageUrl = this.block.innerBlocks[0].attributes.find(
      (attribute) => attribute.name === 'url'
    )

    const imageId = this.block.innerBlocks[0].attributes.find(
      (attribute) => attribute.name === 'id'
    )

    return { url: imageUrl.value, id: imageId.value }
  }

  get phoneElements() {
    if (typeof this.block.innerBlocks[1] === 'undefined') {
      return null
    }

    const phoneHtml = this.block.innerBlocks[1].innerBlocks[0].innerHtml

    const phoneText = phoneHtml.replace(
      new RegExp(
        '<h2 class="has-text-align-center"><a href[^>]*>+(.*)<\/a></h2>'
      ),
      '$1'
    )

    const phoneHref = phoneHtml.replace(
      new RegExp(
        '<h2 class="has-text-align-center"><a href="(.*)">+.*<\/a><\/h2>'
      ),
      '$1'
    )

    return { phoneText, phoneHref }
  }
}
